/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  toGenerateConstantsArray,
  toGenerateInitialSate,
} from '../../services/technique/generateCode';
import models from '../models';

export default Object.values(models).map((item: unknown) => {
  const {attributes, model, entity} = item as {
    attributes: any;
    model: any;
    entity: any;
  };
  return {
    entity,
    constants: toGenerateConstantsArray(model, entity),
    initialState: toGenerateInitialSate(attributes),
  };
});

export const constants = Object.values(models).map((item: unknown) => {
  const {attributes, model, entity} = item as {
    attributes: any;
    model: any;
    entity: any;
  };
  const res = {
    entity,
    constants: toGenerateConstantsArray(model, entity),
    initialState: toGenerateInitialSate(attributes),
  };
  return {[entity]: res};
});
